import { LockStatus, Table } from 'components';
import {
  KY_DATA_APPROVED_SITE_MANAGER,
  STATUS_KY_APPROVE,
  STATUS_LOCKED,
  userRole,
} from 'constant';
import { layoutSelector } from 'containers/Layout/selectors';
import { setLocationDTCAgent } from 'pages/Home/Bo/BusinessDetail/slice';
import { userData } from 'pages/Login/selectors';
import { FC, useCallback, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { UsersType } from 'types';
import { useAppDispatch } from '../../../../hooks';
import { siteDetailSelector } from '../../../SiteDetail/selectors';
import { getUserStatusChart } from '../../../SiteDetail/thunk';
import ModalChart from '../ModalChart';
import SectionStyled from './styles';
// 2024/01/02 Leading Win 教育機能対応 DXWEBWIN00100_作業員情報 start
interface Props {
  // data: WorkersChargeSiteListCooperators[];
  // site_user_schedules: SiteUserSchedulesUsersItem[] | null;
  data: UsersType[];
}
// 2024/01/02 Leading Win 教育機能対応 DXWEBWIN00100_作業員情報 end
const InsuranceName: { [char: number]: string } = {
  0: '未加入',
  1: '加入済',
  2: '期限切れ',
};

const MedicalCheckName: { [char: number]: string } = {
  0: '未受診',
  1: '受診済',
  2: '期限切れ',
};
// 2024/01/02 Leading Win 教育機能対応 DXWEBWIN00100_作業員情報 start
// 2025/02/11 FJ 3月分反映分 NO58 start
// const ComerEducationName: { [char: number]: string } = {
//   0: '未実施',
//   1: '実施済',
//   2: '承認済',
// };
// 2025/02/11 FJ 3月分反映分 NO58 end
// 2024/01/02 Leading Win 教育機能対応 DXWEBWIN00100_作業員情報 end
type tableDataType = {
  cooperator_company_name: string;
  cooperator_id: number;
  user_id: number;
  user_name: string;
  work_type_id: number;
  work_type_name: string;
  start_date: string;
  first_date: string;
  end_date: string;
  // 2024/01/02 Leading Win 教育機能対応 DXWEBWIN00100_作業員情報 start
  // users: CooperatorsUserItem[] | undefined;
  insurance_status: number;
  medical_status: number;
  // 2025/02/11 FJ 3月分反映分 NO58 start
  // newcomer_education_status: number;
  // sendoff_education_status: number;
  // 2025/02/11 FJ 3月分反映分 NO58 end
  // 2024/01/02 Leading Win 教育機能対応 DXWEBWIN00100_作業員情報 end
};

const WorkerInfoSite: FC<Props> = ({ data }) => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const { schedules } = useSelector(siteDetailSelector);
  const { LockStatusData, KYDataApproveBySiteManageDate } = useSelector(layoutSelector);
  const [visible, closeVisible] = useState(false);

  useEffect(() => {
    dispatch(setLocationDTCAgent(location.state));
  }, [dispatch, location.state]);

  const [tableData, setTableData] = useState<tableDataType[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [record, setRecord] = useState<tableDataType>();
  const { roleUser } = useSelector(userData);
  // 2024/01/02 Leading Win 教育機能対応 DXWEBWIN00100_作業員情報 start
  // const usersMap = useMemo(
  //   () => data && data.map((d) => d.users.map((u) => u.user_id)).flat(),
  //   [data]
  // );
  // const userUniq = useMemo(() => usersMap && uniqBy(usersMap, (u) => u), [usersMap]);
  const convertDataTable = useCallback(async () => {
    if (!data || !dispatch) return;
    setLoading(true);
    // const userList = await Promise.all(
    //   data.map(async (id) => {
    //     let users: CooperatorsUserItem[] | undefined;
    //     const getCooperatorUserAction = await dispatch(getCooperatorUser({ user_id: id }));
    //     if (getCooperatorUser.fulfilled.match(getCooperatorUserAction)) {
    //       users = getCooperatorUserAction.payload.cooperators;
    //     }
    //     return users ? { users, id } : users;
    //   })
    // );
    // const users = userList.filter((u) => u);

    const newData = await Promise.all(
      data.map(async (d) => {
        // return await Promise.all(
        //   d.map(async (u) => {
        //     // const user_id = u.user_id;
        //     // const user_name = u.user_name;

        //     // const site = site_user_schedules.filter((u) => u.user_id === user_id);
        //     // const work_type_id = site[0]?.schedules[0]?.work_type_id;
        //     // const work_type_name = site[0]?.schedules[0]?.work_type_name;
        //     // const start_date = site[0]?.schedules[0]?.from_date;
        //     // const first_date = site[0]?.schedules[0]?.first_enter_date;
        //     // const end_date = site[0]?.schedules[0]?.to_date;

        //     return {
        //       cooperator_company_name: d.cooperator_company_name,
        //       cooperator_id: d.cooperator_id,
        //       user_id,
        //       user_name,
        //       work_type_id,
        //       work_type_name,
        //       start_date,
        //       first_date,
        //       end_date,
        //       users: users.filter((u) => u?.id === user_id)?.[0]?.users,
        //     };
        //   })

        // );
        return {
          cooperator_company_name: d.cooperator_name,
          cooperator_id: Number(d.cooperator_id),
          user_id: Number(d.user_id),
          user_name: d.worker_name,
          work_type_id: Number(d.work_type_id),
          work_type_name: d.work_name,
          start_date: d.start_date,
          first_date: d.new_admission,
          end_date: d.end_date,
          insurance_status: Number(d.insurance_status),
          medical_status: Number(d.medical_status),
          // 2025/02/11 FJ 3月分反映分 NO58 start
          // newcomer_education_status: Number(d.newcomer_education_status),
          // sendoff_education_status: Number(d.sendoff_education_status),
          // 2025/02/11 FJ 3月分反映分 NO58 end
        };
      })
    );

    setLoading(false);
    return newData.flat();
  }, [data, dispatch]);
  const getTImeOut = useRef<NodeJS.Timeout | null>(null);
  useEffect(() => {
    if (getTImeOut.current) {
      clearTimeout(getTImeOut.current);
    }
    getTImeOut.current = setTimeout(
      () =>
        (async () => {
          const data = await convertDataTable();
          data && setTableData(data);
        })(),
      500
    );
  }, [convertDataTable]);
  // 2024/01/02 Leading Win 教育機能対応 DXWEBWIN00100_作業員情報 end
  const handleClick = async (record: tableDataType) => {
    dispatch(getUserStatusChart({ user_id: record.user_id }));

    setRecord(record);
    closeVisible(true);
  };

  return (
    <SectionStyled>
      <ModalChart
        visible={visible}
        closeVisible={closeVisible}
        record={record}
        schedules={schedules.data}
      />
      <div className="container-table">
        <div className="lock-status-container">
          <LockStatus
            text={LockStatusData?.site_name}
            roleStatus={{
              text:
                KYDataApproveBySiteManageDate?.[
                  userRole.DTC === roleUser
                    ? `site_director_approval_flag`
                    : `site_manager_approval_flag`
                ] === KY_DATA_APPROVED_SITE_MANAGER.true
                  ? 'RKY承認済'
                  : 'RKY未承認',
              lock:
                KYDataApproveBySiteManageDate?.[
                  userRole.DTC === roleUser
                    ? `site_director_approval_flag`
                    : `site_manager_approval_flag`
                ] === STATUS_KY_APPROVE.true,
            }}
            lockStatus={{
              text: LockStatusData?.status_locked === STATUS_LOCKED.true ? '施錠済' : '未施錠',
              lock: LockStatusData?.status_locked === STATUS_LOCKED.true,
            }}
            code={LockStatusData?.building_code}
          />
        </div>
        <Table
          columns={columns}
          dataSource={tableData}
          loading={loading}
          onRow={(record) => ({
            onClick: () => {
              handleClick(record);
            },
          })}
        />
      </div>
    </SectionStyled>
  );
};

const columns = [
  {
    title: '所属業者',
    dataIndex: 'work_type_name',
    width: '15%',
    className: 'boder-left',
    render: (
      work_type_name: string,
      row: {
        cooperator_company_name?: string;
      }
    ) => {
      const { cooperator_company_name } = row;
      return <div>{cooperator_company_name || '-'}</div>;
    },
  },
  {
    title: '工種',
    dataIndex: 'work_type_name',
    className: 'boder-left',
    render: (work_type_name: string) => {
      return <div>{work_type_name || '-'}</div>;
    },
  },
  {
    title: '名前',
    dataIndex: 'user_name',
    className: 'boder-left',
    render: (user_name: string) => {
      return <div>{user_name || '-'}</div>;
    },
  },
  {
    title: '入場日',
    dataIndex: 'first_date',
    className: 'boder-left',
    render: (first_date: string) => {
      if (first_date === 'Invalid Date') {
        return '-';
      }
      return <div>{first_date}</div>;
    },
  },
  {
    title: '開始日',
    dataIndex: 'start_date',
    className: 'boder-left',
    render: (start_date: string) => {
      if (start_date === 'Invalid Date') {
        return '未入力';
      }
      return <div>{start_date}</div>;
    },
  },
  {
    title: '終了日',
    dataIndex: 'end_date',
    className: 'boder-left',
    width: '10%',
    render: (end_date: string) => {
      return <div>{end_date || '未入力'}</div>;
    },
  },
  // 2024/01/02 Leading Win 教育機能対応 DXWEBWIN00100_作業員情報 start
  {
    title: '保険状況',
    dataIndex: 'insurance_status',
    className: 'boder-left',
    render: (insurance_status: number) => {
      return insurance_status ? (
        <div
          className={
            ['未加入', '期限切れ'].includes(InsuranceName[insurance_status]) ? 'text-red' : ''
          }
        >
          {InsuranceName[insurance_status]}
        </div>
      ) : (
        <div className={'text-red'}>{InsuranceName[0]}</div>
      );
    },
  },
  {
    title: '健康診断',
    dataIndex: 'medical_status',
    className: 'boder-left',
    render: (medical_status: number) => {
      return medical_status ? (
        <div
          className={
            ['期限切れ', '未受診'].includes(MedicalCheckName[medical_status]) ? 'text-red' : ''
          }
        >
          {MedicalCheckName[medical_status]}
        </div>
      ) : (
        <div className={'text-red'}>{MedicalCheckName[0]}</div>
      );
    },
  },
  // 2025/02/11 FJ 3月分反映分 NO58 start
  // {
  //   title: '新規入場者教育',
  //   dataIndex: 'newcomer_education_status',
  //   className: 'boder-left',
  //   width: '10%',
  //   render: (newcomer_education_status: number) => {
  //     return newcomer_education_status ? (
  //       <div>{ComerEducationName[newcomer_education_status]}</div>
  //     ) : (
  //       <div>{ComerEducationName[0]}</div>
  //     );
  //   },
  // },
  // {
  //   title: '送り出し教育',
  //   dataIndex: 'sendoff_education_status',
  //   className: 'boder-left',
  //   width: '10%',
  //   render: (sendoff_education_status: number) => {
  //     return sendoff_education_status ? (
  //       <div>{ComerEducationName[sendoff_education_status]}</div>
  //     ) : (
  //       <div>{ComerEducationName[0]}</div>
  //     );
  //   },
  // },
  // 2025/02/11 FJ 3月分反映分 NO58 end
  // 2024/01/02 Leading Win 教育機能対応 DXWEBWIN00100_作業員情報 end
];

export default WorkerInfoSite;
